"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./util");
const logger_1 = require("./logger");
class API {
    constructor(_options) {
        this._options = _options;
    }
    _buildUrl(method) {
        const protocol = this._options.secure ? "https://" : "http://";
        let url = protocol +
            this._options.host +
            ":" +
            this._options.port +
            this._options.path +
            this._options.key +
            "/" +
            method;
        const queryString = "?ts=" + new Date().getTime() + "" + Math.random();
        url += queryString;
        return url;
    }
    /** Get a unique ID from the server via XHR and initialize with it. */
    retrieveId() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this._buildUrl("id");
            try {
                const response = yield fetch(url);
                if (response.status !== 200) {
                    throw new Error(`Error. Status:${response.status}`);
                }
                return response.text();
            }
            catch (error) {
                logger_1.default.error("Error retrieving ID", error);
                let pathError = "";
                if (this._options.path === "/" &&
                    this._options.host !== util_1.util.CLOUD_HOST) {
                    pathError =
                        " If you passed in a `path` to your self-hosted PeerServer, " +
                            "you'll also need to pass in that same path when creating a new " +
                            "Peer.";
                }
                throw new Error("Could not get an ID from the server." + pathError);
            }
        });
    }
    /** @deprecated */
    listAllPeers() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this._buildUrl("peers");
            try {
                const response = yield fetch(url);
                if (response.status !== 200) {
                    if (response.status === 401) {
                        let helpfulError = "";
                        if (this._options.host === util_1.util.CLOUD_HOST) {
                            helpfulError =
                                "It looks like you're using the cloud server. You can email " +
                                    "team@peerjs.com to enable peer listing for your API key.";
                        }
                        else {
                            helpfulError =
                                "You need to enable `allow_discovery` on your self-hosted " +
                                    "PeerServer to use this feature.";
                        }
                        throw new Error("It doesn't look like you have permission to list peers IDs. " +
                            helpfulError);
                    }
                    throw new Error(`Error. Status:${response.status}`);
                }
                return response.json();
            }
            catch (error) {
                logger_1.default.error("Error retrieving list peers", error);
                throw new Error("Could not get list peers from the server." + error);
            }
        });
    }
}
exports.API = API;
